import m from 'mithril'
import {Component, classes} from '@codeurs/front'

import './contentcontainer.less'

export default class ContentContainer extends Component<{
	mod?: string
	[key: string]: any
}> {
	view() {
		const {mod, ...attrs} = this.attrs
		return m('.contentcontainer',
			{
				...classes({mod}),
				...attrs
			},
			this.children
		)
	}
}
